import { Section } from "../../entities/Section";
import { ISectionsRepository } from "../../repositories/ISectionsRepository";

export class GetPrologueUseCase
{
    constructor(
        private sectionsRepository: ISectionsRepository
    ) {}

    async execute(): Promise<Section|null>
    {
        const prologue = await this.sectionsRepository.getPrologue();

        return prologue;
    }
}